import React, { useId } from 'react';

/**
 * TenderWright mark — the plumb-bob.
 * The plumb-bob is the wright's tool of truth (vertical, exact, unambiguous).
 * Datum line + plumb cord + brass bob = one gesture, legible from 16px upward.
 *
 * useId() namespaces the gradient IDs so multiple instances on a page
 * (sidebar + dropdown + auth panel) don't collide.
 */
export default function TenderWrightLogo({ size = 36, title = 'TenderWright' }) {
  const uid = useId().replace(/[^a-zA-Z0-9]/g, '');
  const bgId = `tw-bg-${uid}`;
  const glowId = `tw-glow-${uid}`;
  const brassId = `tw-brass-${uid}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <defs>
        <linearGradient id={bgId} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0E2543" />
          <stop offset="1" stopColor="#0A1A2E" />
        </linearGradient>
        <radialGradient id={glowId} cx="0.25" cy="0.2" r="0.9">
          <stop offset="0" stopColor="#1A56DB" stopOpacity="0.32" />
          <stop offset="1" stopColor="#1A56DB" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={brassId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#F4C56A" />
          <stop offset="0.55" stopColor="#E8A838" />
          <stop offset="1" stopColor="#A8731F" />
        </linearGradient>
      </defs>

      <rect width="48" height="48" rx="10" fill={`url(#${bgId})`} />
      <rect width="48" height="48" rx="10" fill={`url(#${glowId})`} />

      {/* Datum line */}
      <rect x="9" y="11" width="30" height="2.4" rx="0.4" fill="#FFFFFF" />
      {/* Anchor notch */}
      <rect x="22.7" y="13.4" width="2.6" height="2" fill={`url(#${brassId})`} />
      {/* Plumb cord */}
      <rect x="23.4" y="15.2" width="1.2" height="17" fill="#FFFFFF" opacity="0.85" />

      {/* Brass plumb-bob */}
      <path d="M24 32 L31 36.5 L24 44 L17 36.5 Z" fill={`url(#${brassId})`} />
      <path d="M24 32 L31 36.5 L24 36.5 Z" fill="#FFFFFF" opacity="0.18" />
      <path d="M24 36.5 L31 36.5 L24 44 Z" fill="#000000" opacity="0.18" />
      <line x1="24" y1="32" x2="24" y2="44" stroke="#0A1A2E" strokeWidth="0.5" opacity="0.4" />

      {/* Precision tip */}
      <circle cx="24" cy="44.4" r="0.7" fill="#FFFFFF" />
    </svg>
  );
}
